(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var body = document.querySelector('[data-cart-drawer-body]');
  var scrim = document.querySelector('.fh-cart-drawer-scrim');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartCountEls = document.querySelectorAll('.header-cart-count');
  var cartUrl = drawer ? drawer.getAttribute('data-cart-url') || '/cart' : '/cart';
  var checkoutUrl = drawer ? drawer.getAttribute('data-checkout-url') || '/checkout' : '/checkout';
  var shopUrl = drawer ? drawer.getAttribute('data-shop-url') || '/collections/all' : '/collections/all';
  var freeShippingEnabled = drawer ? drawer.getAttribute('data-free-shipping-enabled') !== 'false' : true;
  var freeShippingThreshold = drawer ? parseInt(drawer.getAttribute('data-free-shipping-threshold'), 10) || 8900 : 8900;
  var freeShippingUnlockedText = drawer ? drawer.getAttribute('data-free-shipping-unlocked') || 'Free shipping unlocked' : 'Free shipping unlocked';
  var freeShippingRemainingText = drawer ? drawer.getAttribute('data-free-shipping-remaining') || 'away from free shipping' : 'away from free shipping';
  var confirmation = document.querySelector('[data-cart-confirmation]');
  var lastCartFocus = null;
  var confirmationTimer = null;
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector)).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function isCartOpen() {
    return drawer && drawer.classList.contains('fh-cart-drawer--open') && !drawer.hidden;
  }

  function trapCartFocus(event) {
    if (event.key !== 'Tab' || !isCartOpen()) return;
    var focusable = getFocusable(drawer);
    if (!focusable.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function money(cents) {
    var amount = cents / 100;
    try {
      return amount.toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    } catch (error) {
      return '$' + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
    }
  }

  function isSafeUrl(url) {
    if (!url || typeof url !== 'string') return false;
    if (url.charAt(0) === '/' && url.charAt(1) !== '/') return true;
    try {
      var parsed = new URL(url.indexOf('//') === 0 ? window.location.protocol + url : url, window.location.origin);
      var host = parsed.hostname.toLowerCase();
      var protocolAllowed = parsed.protocol === 'https:' || parsed.protocol === 'http:';
      var hostAllowed = host === window.location.hostname.toLowerCase() ||
        host === 'fearlessharbor.com' ||
        host === 'www.fearlessharbor.com' ||
        host === 'cdn.shopify.com' ||
        host === 'cdn.shopifycdn.com' ||
        host === 'cdn.shopifycdn.net' ||
        host.endsWith('.myshopify.com') ||
        host.endsWith('.shopifycdn.com') ||
        host.endsWith('.shopifycdn.net');
      return protocolAllowed && hostAllowed;
    } catch (error) {
      return false;
    }
  }

  function safeUrl(url, fallback) {
    return isSafeUrl(url) ? url : fallback;
  }

  function appendWidthParam(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function clearElement(element) {
    while (element.firstChild) element.removeChild(element.firstChild);
  }

  function createTextElement(tagName, className, text) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    el.textContent = text || '';
    return el;
  }

  function setSafeHref(link, url, fallback) {
    link.setAttribute('href', safeUrl(url, fallback || '#'));
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function renderProperties(properties) {
    if (!properties) return null;
    var keys = Object.keys(properties).filter(function (key) {
      return properties[key] && key.charAt(0) !== '_';
    });
    if (!keys.length) return null;

    var list = document.createElement('dl');
    list.className = 'fh-cart-drawer-item__properties';
    keys.forEach(function (key) {
      var row = document.createElement('div');
      var term = document.createElement('dt');
      var detail = document.createElement('dd');
      var value = String(properties[key]);

      term.textContent = key;
      if (value.indexOf('/uploads/') > -1 && isSafeUrl(value)) {
        var uploadLink = document.createElement('a');
        uploadLink.textContent = 'Uploaded file';
        setSafeHref(uploadLink, value, '#');
        uploadLink.setAttribute('target', '_blank');
        uploadLink.setAttribute('rel', 'noopener');
        detail.appendChild(uploadLink);
      } else {
        detail.textContent = value;
      }

      row.appendChild(term);
      row.appendChild(detail);
      list.appendChild(row);
    });
    return list;
  }

  function renderFreeShipping(cart) {
    if (!freeShippingEnabled) return null;
    var remaining = Math.max(0, freeShippingThreshold - cart.total_price);
    var progress = freeShippingThreshold > 0 ? Math.min(100, Math.round((cart.total_price / freeShippingThreshold) * 100)) : 100;
    var text = remaining <= 0 ? freeShippingUnlockedText : money(remaining) + ' ' + freeShippingRemainingText;

    var wrapper = document.createElement('div');
    var copy = document.createElement('p');
    var track = document.createElement('span');
    var fill = document.createElement('span');

    wrapper.className = 'fh-cart-free-shipping';
    wrapper.setAttribute('aria-label', 'Free shipping status');
    copy.textContent = text;
    track.className = 'fh-cart-free-shipping__track';
    track.setAttribute('aria-hidden', 'true');
    fill.style.width = progress + '%';

    track.appendChild(fill);
    wrapper.appendChild(copy);
    wrapper.appendChild(track);
    return wrapper;
  }

  function renderEmptyCart() {
    var empty = document.createElement('div');
    var points = document.createElement('ul');
    var link = document.createElement('a');

    empty.className = 'fh-cart-drawer__empty';
    empty.appendChild(createTextElement('p', 'eyebrow', 'Hunt apparel'));
    empty.appendChild(createTextElement('h3', '', 'Your cart is empty.'));
    empty.appendChild(createTextElement('p', '', 'Start with graphic tees, hats, and everyday wear built around camp, town, and the drive between seasons.'));
    points.className = 'fh-cart-drawer__empty-points';
    ['Secure Shopify checkout', 'Shipping shown before payment', 'Easy cart review'].forEach(function (text) {
      points.appendChild(createTextElement('li', '', text));
    });
    link.className = 'btn btn--primary';
    link.textContent = 'Shop all';
    setSafeHref(link, shopUrl, '/collections/all');

    empty.appendChild(points);
    empty.appendChild(link);
    return empty;
  }

  function renderCartItem(item, index) {
    var article = document.createElement('article');
    var media = document.createElement('a');
    var details = document.createElement('div');
    var title = document.createElement('a');
    var controls = document.createElement('div');
    var stepper = document.createElement('div');
    var decrease = document.createElement('button');
    var increase = document.createElement('button');
    var label = document.createElement('label');
    var hiddenLabel = document.createElement('span');
    var input = document.createElement('input');
    var remove = document.createElement('button');
    var desktopPrice = createTextElement('p', 'fh-cart-drawer-item__price fh-cart-drawer-item__price--desktop', money(item.final_line_price));
    var productTitle = item.product_title || 'Item';

    article.className = 'fh-cart-drawer-item';
    article.setAttribute('data-cart-line', String(index + 1));

    media.className = 'fh-cart-drawer-item__media';
    setSafeHref(media, item.url, cartUrl);
    if (item.image && isSafeUrl(item.image)) {
      var image = document.createElement('img');
      image.src = appendWidthParam(item.image, 180);
      image.alt = productTitle;
      image.loading = 'lazy';
      media.appendChild(image);
    }

    details.className = 'fh-cart-drawer-item__details';
    title.className = 'fh-cart-drawer-item__title';
    title.textContent = productTitle;
    setSafeHref(title, item.url, cartUrl);
    details.appendChild(title);
    details.appendChild(createTextElement('p', 'fh-cart-drawer-item__price fh-cart-drawer-item__price--mobile', money(item.final_line_price)));

    if (item.variant_title) {
      details.appendChild(createTextElement('p', 'fh-cart-drawer-item__variant', item.variant_title));
    }

    var properties = renderProperties(item.properties);
    if (properties) details.appendChild(properties);

    if (item.discounts && item.discounts.length) {
      var discounts = document.createElement('ul');
      discounts.className = 'fh-cart-drawer-item__discounts';
      item.discounts.forEach(function (discount) {
        discounts.appendChild(createTextElement('li', '', discount.title));
      });
      details.appendChild(discounts);
    }

    controls.className = 'fh-cart-drawer-item__controls';
    stepper.className = 'fh-cart-quantity-stepper';
    stepper.setAttribute('aria-label', 'Quantity for ' + productTitle);

    decrease.type = 'button';
    decrease.setAttribute('data-cart-quantity-decrease', '');
    decrease.setAttribute('aria-label', 'Decrease quantity for ' + productTitle);
    decrease.textContent = '−';

    hiddenLabel.className = 'visually-hidden';
    hiddenLabel.textContent = 'Quantity for ' + productTitle;
    input.type = 'number';
    input.min = '0';
    input.value = item.quantity;
    input.setAttribute('data-cart-quantity', '');
    label.appendChild(hiddenLabel);
    label.appendChild(input);

    increase.type = 'button';
    increase.setAttribute('data-cart-quantity-increase', '');
    increase.setAttribute('aria-label', 'Increase quantity for ' + productTitle);
    increase.textContent = '+';

    remove.type = 'button';
    remove.setAttribute('data-cart-remove', '');
    remove.textContent = 'Remove';

    stepper.appendChild(decrease);
    stepper.appendChild(label);
    stepper.appendChild(increase);
    controls.appendChild(stepper);
    controls.appendChild(remove);
    details.appendChild(controls);

    article.appendChild(media);
    article.appendChild(details);
    article.appendChild(desktopPrice);
    return article;
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (!body) return;
    clearElement(body);

    if (!cart.items.length) {
      body.appendChild(renderEmptyCart());
      return;
    }

    var itemsWrapper = document.createElement('div');
    var summary = document.createElement('div');
    var subtotal = document.createElement('p');
    var subtotalLabel = document.createElement('span');
    var subtotalValue = document.createElement('strong');
    var checkoutLink = document.createElement('a');
    var cartLink = document.createElement('a');
    var freeShipping = renderFreeShipping(cart);

    itemsWrapper.className = 'fh-cart-drawer__items';
    cart.items.forEach(function (item, index) {
      itemsWrapper.appendChild(renderCartItem(item, index));
    });

    summary.className = 'fh-cart-drawer__summary';
    if (freeShipping) summary.appendChild(freeShipping);

    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      var discounts = document.createElement('ul');
      discounts.className = 'fh-cart-drawer__discounts';
      cart.cart_level_discount_applications.forEach(function (discount) {
        discounts.appendChild(createTextElement('li', '', discount.title + ': -' + money(discount.total_allocated_amount)));
      });
      summary.appendChild(discounts);
    }

    subtotalLabel.textContent = 'Subtotal';
    subtotalValue.textContent = money(cart.total_price);
    subtotal.appendChild(subtotalLabel);
    subtotal.appendChild(subtotalValue);
    summary.appendChild(subtotal);
    summary.appendChild(createTextElement('small', '', 'Taxes, shipping, and final discounts calculated at checkout.'));

    checkoutLink.className = 'btn btn--primary';
    checkoutLink.textContent = 'Checkout';
    setSafeHref(checkoutLink, checkoutUrl, '/checkout');
    cartLink.className = 'btn btn--secondary';
    cartLink.textContent = 'View cart';
    setSafeHref(cartLink, cartUrl, '/cart');

    summary.appendChild(checkoutLink);
    summary.appendChild(cartLink);
    body.appendChild(itemsWrapper);
    body.appendChild(summary);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function refreshCart() {
    return fetchCart().then(renderCart);
  }

  function showAddConfirmation(item, cart) {
    if (!confirmation) return;
    clearElement(confirmation);

    var inner = document.createElement('div');
    var copy = document.createElement('div');
    var actions = document.createElement('div');
    var cartLink = document.createElement('a');
    var checkoutLink = document.createElement('a');
    var closeButton = document.createElement('button');
    var productTitle = item && item.product_title ? item.product_title : 'Item';
    var quantity = item && item.quantity ? item.quantity : 1;

    inner.className = 'fh-cart-confirmation__inner';
    if (item && item.image && isSafeUrl(item.image)) {
      var image = document.createElement('img');
      image.src = appendWidthParam(item.image, 120);
      image.alt = '';
      image.loading = 'lazy';
      inner.appendChild(image);
    }

    copy.className = 'fh-cart-confirmation__copy';
    copy.appendChild(createTextElement('p', 'fh-cart-confirmation__eyebrow', 'Added to cart'));
    copy.appendChild(createTextElement('p', 'fh-cart-confirmation__title', productTitle));
    copy.appendChild(createTextElement('p', 'fh-cart-confirmation__meta', quantity + ' in cart · ' + money(cart.total_price) + ' subtotal'));

    actions.className = 'fh-cart-confirmation__actions';
    cartLink.textContent = 'View cart';
    setSafeHref(cartLink, cartUrl, '/cart');
    checkoutLink.textContent = 'Checkout';
    setSafeHref(checkoutLink, checkoutUrl, '/checkout');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Dismiss cart confirmation');
    closeButton.setAttribute('data-cart-confirmation-close', '');
    closeButton.textContent = '×';

    actions.appendChild(cartLink);
    actions.appendChild(checkoutLink);
    actions.appendChild(closeButton);
    inner.appendChild(copy);
    inner.appendChild(actions);
    confirmation.appendChild(inner);
    confirmation.hidden = false;
    confirmation.classList.add('is-visible');
    if (confirmationTimer) window.clearTimeout(confirmationTimer);
    confirmationTimer = window.setTimeout(function () {
      confirmation.classList.remove('is-visible');
      confirmation.hidden = true;
    }, 6500);
  }

  function openCart() {
    if (!drawer) return;
    lastCartFocus = document.activeElement;
    drawer.hidden = false;
    drawer.removeAttribute('inert');
    drawer.classList.add('fh-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    cartOpeners.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'true');
    });
    if (scrim) scrim.classList.add('fh-cart-drawer-scrim--open');
    document.documentElement.classList.add('fh-cart-drawer-is-open');
    refreshCart().then(function () {
      var closeButton = drawer.querySelector('[data-cart-close]');
      if (closeButton) closeButton.focus();
    }).catch(function () {});
  }

  function closeCart() {
    if (!isCartOpen()) return;
    drawer.classList.remove('fh-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    drawer.hidden = true;
    cartOpeners.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    if (scrim) scrim.classList.remove('fh-cart-drawer-scrim--open');
    document.documentElement.classList.remove('fh-cart-drawer-is-open');
    if (lastCartFocus && typeof lastCartFocus.focus === 'function') lastCartFocus.focus();
  }

  function updateProductCardImage(swatch) {
    var card = swatch.closest('.fh-product-card');
    var img = card && card.querySelector('[data-product-card-image]');
    var image = swatch.getAttribute('data-card-swatch-image');
    if (img && image && isSafeUrl(image) && img.src !== image) {
      img.src = image;
      img.removeAttribute('srcset');
      img.alt = swatch.getAttribute('data-card-swatch-alt') || img.alt;
    }
    if (card) {
      card.querySelectorAll('[data-product-card-swatch]').forEach(function (button) {
        button.classList.toggle('is-active', button === swatch);
      });
    }
  }

  function preloadProductCardSwatch(swatch) {
    var image = swatch.getAttribute('data-card-swatch-image');
    if (!image || !isSafeUrl(image) || swatch.dataset.swatchPreloaded === 'true') return;
    var preload = new Image();
    preload.src = image;
    swatch.dataset.swatchPreloaded = 'true';
  }

  function getEventElement(event) {
    return event && event.target instanceof Element ? event.target : null;
  }

  cartOpeners.forEach(function (opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      openCart();
    });
  });

  document.addEventListener('click', function (event) {
    var target = getEventElement(event);
    if (!target) return;

    if (target.closest('[data-cart-close]')) closeCart();

    var swatch = target.closest('[data-product-card-swatch]');
    if (swatch) {
      updateProductCardImage(swatch);
    }

    var removeButton = target.closest('[data-cart-remove]');
    if (removeButton) {
      var removeLine = removeButton.closest('[data-cart-line]');
      if (removeLine) changeLine(removeLine.getAttribute('data-cart-line'), 0);
    }

    var decreaseButton = target.closest('[data-cart-quantity-decrease]');
    var increaseButton = target.closest('[data-cart-quantity-increase]');
    if (decreaseButton || increaseButton) {
      var stepperLine = target.closest('[data-cart-line]');
      var quantityInput = stepperLine && stepperLine.querySelector('[data-cart-quantity]');
      if (stepperLine && quantityInput) {
        var currentQuantity = parseInt(quantityInput.value, 10) || 0;
        var nextQuantity = Math.max(0, currentQuantity + (increaseButton ? 1 : -1));
        quantityInput.value = nextQuantity;
        changeLine(stepperLine.getAttribute('data-cart-line'), nextQuantity);
      }
    }

    if (target.closest('[data-cart-confirmation-close]')) {
      if (confirmationTimer) window.clearTimeout(confirmationTimer);
      if (confirmation) {
        confirmation.classList.remove('is-visible');
        confirmation.hidden = true;
      }
    }
  });

  document.addEventListener('change', function (event) {
    var target = getEventElement(event);
    if (target && target.matches('[data-cart-quantity]')) {
      var line = target.closest('[data-cart-line]');
      if (line) changeLine(line.getAttribute('data-cart-line'), Math.max(0, parseInt(target.value, 10) || 0));
    }
  });

  document.addEventListener('pointerenter', function (event) {
    var target = getEventElement(event);
    var swatch = target && target.closest('[data-product-card-swatch]');
    if (swatch) {
      preloadProductCardSwatch(swatch);
      updateProductCardImage(swatch);
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    var target = getEventElement(event);
    var swatch = target && target.closest('[data-product-card-swatch]');
    if (swatch) {
      preloadProductCardSwatch(swatch);
      updateProductCardImage(swatch);
    }
  });

  document.querySelectorAll('[data-product-card-swatch]').forEach(function (swatch, index) {
    if (index < 24) preloadProductCardSwatch(swatch);
  });

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }).then(renderCart).catch(function () {
      window.location.href = safeUrl(cartUrl, '/cart');
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-product-form], form[action*="/cart/add"]')) return;
    event.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    }).then(function(addedItem) {
      return fetchCart().then(function(cart) {
        renderCart(cart);
        showAddConfirmation(addedItem, cart);
      });
    }).catch(function () {
      HTMLFormElement.prototype.submit.call(form);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (!isCartOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeCart();
      return;
    }
    trapCartFocus(event);
  });

  refreshCart().catch(function () {});
})();
